<template>
  <div id="app">
    <AttributeWrapper>
      <Background>
        <ContentBlock/>
      </Background>
      <ProjectPreview/>
    </AttributeWrapper>
  </div>
</template>

<script>
  import AttributeWrapper from './components/AttributeWrapper';
  import Background from './components/Background';
  import ContentBlock from './components/ContentBlock';
  import ProjectPreview from './components/ProjectPreview';

  export default {
    name: 'app',
    components: {
      ProjectPreview,
      ContentBlock,
      Background,
      AttributeWrapper,
    },
  }
</script>

<style lang="less">
  @import './shared.less';
  @import './assets/fonts/montserrat/font.less';


  html {
    height: 100%;
  }

  body {
    height: 100%;
    margin: 0;
    background-color: @colors[background];
    color: @colors[text];
    font-family: @font-sets[main];
    font-size: @font-sizes[normal];

    @media @vertical {
      font-size: @font-sizes-v[normal];
    }

    @media @mobile {
      font-size: @font-sizes-m[normal];
    }

    @media @mobile-vertical {
      font-size: @font-sizes-mv[normal];
    }
  }

  #app {
    height: 100%;
  }

  a {
    color: @colors[text];
    text-decoration: none;
  }
</style>
